<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-toolbar
      class="primaryLight white--text"
      dense
    >
      <div>CARACTERÍSTICAS DEL INCENDIO</div>
    </v-toolbar>
    <v-card-text>
      <div
        class="mb-2 font-weight-bold"
      >
        Tamaño del incendio en el momento de la solicitud*
      </div>
      <v-radio-group
        v-model="datos.tamIncendio"
        hide-details
        :rules="reglas.requerido"
      >
        <v-radio
          label="<=25hc"
          value="1"
        />
        <v-radio
          label="26-100hc"
          value="4"
        />
        <v-radio
          label="101-500hc"
          value="3"
        />
        <v-radio
          label=">500hc"
          value="2"
        />
      </v-radio-group>

      <div
        class="mt-4 font-weight-bold"
      >
        Bienes amenazados por el fuego*
      </div>
      <v-row>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.bienes.poblacion"
            label="Poblaciones"
            :true-value="1"
            :false-value="0"
            :rules="reglaBienes"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.bienes.infraestructuras"
            label="Infraestructuras"
            :true-value="1"
            :false-value="0"
            :rules="reglaBienes"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.bienes.espaciosNaturales"
            label="Espacios Naturales"
            :true-value="1"
            :false-value="0"
            :rules="reglaBienes"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.bienes.bosques"
            label="Bosques"
            :true-value="1"
            :false-value="0"
            :rules="reglaBienes"
            hide-details
          />
        </v-col>
      </v-row>

      <div
        class="mt-4 font-weight-bold"
      >
        Tipo de fuego*
      </div>
      <v-row>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.fuego.pasto"
            label="De pastos"
            :true-value="1"
            :false-value="0"
            :rules="reglaFuego"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.fuego.copas"
            label="De copas"
            :true-value="1"
            :false-value="0"
            :rules="reglaFuego"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.fuego.matorral"
            label="De matorral"
            :true-value="1"
            :false-value="0"
            :rules="reglaFuego"
            hide-details
          />
        </v-col>
      </v-row>

      <div
        class="mt-4 font-weight-bold"
      >
        Relieve*
      </div>
      <v-row>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.relieve.llano"
            label="Llano"
            :true-value="1"
            :false-value="0"
            :rules="reglaRelieve"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.relieve.ondulado"
            label="Ondulado"
            :true-value="1"
            :false-value="0"
            :rules="reglaRelieve"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            v-model="datos.relieve.quebrado"
            label="Quebrado"
            :true-value="1"
            :false-value="0"
            :rules="reglaRelieve"
            hide-details
          />
        </v-col>
      </v-row>

      <div
        class="mt-4 font-weight-bold"
      >
        Líneas eléctricas*
      </div>
      <v-radio-group
        v-model="datos.lineasElectricas"
        row
        :rules="reglas.requerido"
        hide-details
      >
        <v-radio
          label="Sí"
          value="Si"
        />
        <v-radio
          label="No"
          value="No"
        />
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true }
  },
  data: () => ({
    reglas: { requerido: [v => !!v || 'Campo obligatorio'] }
  }),
  computed: {
    datos: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    reglaBienes() { return [() => Object.values(this.datos.bienes).some(v => v === 1) || 'Seleccione un bien amenazado'] },
    reglaFuego() { return [() => Object.values(this.datos.fuego).some(v => v === 1) || 'Seleccione un tipo de fuego'] },
    reglaRelieve() { return [() => Object.values(this.datos.relieve).some(v => v === 1) || 'Seleccione un relieve'] }
  }
}
</script>
